import axios from 'axios';
import  { serviceUrl } from '../../App';
export const getShiftWorkbenchSettings = (type: string) => {
  return axios.get(
    process.env.REACT_APP_API_GLOBAL_URL+`shift-workbench/settings?where=` + type
  );
};
export const AddShiftWorkbenchSettings = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    process.env.REACT_APP_API_GLOBAL_URL+`shift-workbench/settings/create`,
    obj,
    { headers }
  );
};

export const EditShiftWorkbenchSettings = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    process.env.REACT_APP_API_GLOBAL_URL+`shift-workbench/settings/edit`,
    obj,
    { headers }
  );
};

export const DeleteShiftWorkbenchSettings = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    process.env.REACT_APP_API_GLOBAL_URL+`shift-workbench/settings/delete`,
    obj,
    { headers }
  );
};
